/* import __COLOCATED_TEMPLATE__ from './image.hbs'; */
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';

@tagName('')
export default class SharedImage extends Component {}
